import React from "react"

import { FiFile } from "react-icons/fi"

const ProductAccordionListItem = ({ linkTo, children }) => (
  <a
    href={linkTo}
    className="accordion__list-item"
    target="_blank"
    rel="noopener noreferrer"
  >
    <li>
      <FiFile style={{ marginRight: "0.25rem" }} />
      <span>{children}</span>
    </li>
  </a>
)

export default ProductAccordionListItem
